// extracted by mini-css-extract-plugin
module.exports = {"AssuredQuality":"assuredQuality_AssuredQuality__NZ3u3","icon":"assuredQuality_icon__3Hw9t","text":"assuredQuality_text__Kpe__","learnMore":"assuredQuality_learnMore__MM9pq"};